/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductionPlanUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.ProductionPlanUpdatePage
);
